import {Injectable} from '@angular/core';
import {PasswordService} from './password.service';
import {FreeTrialAccount} from '../models/free-trial.model';
import {DataService} from './data.service';
import {AccountService} from './account.service';
import {ReplaySubject} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class FreeTrialService {
    constructor(private passwordService: PasswordService,
                private dataService: DataService,
                private accountService : AccountService) {
    }
    
    private _freeTrialInitialized$ = new ReplaySubject<boolean>(1);
    
    public freeTrialInitialized$ = this._freeTrialInitialized$.asObservable();
    
    public mockRegisterWithoutData() {
        this._freeTrialInitialized$.next(true);
    }
    
    public registerFreeTrialAccount(freeTrialAccount: FreeTrialAccount, first: string) {
        if (!freeTrialAccount.submit_id_c) {
            freeTrialAccount.submit_id_c = this.passwordService.generateUuid().replace(/-/g, '');
        }
        
        if (!freeTrialAccount.password) {
            freeTrialAccount.password = this.passwordService.generatePassword(10);
        }
        
        freeTrialAccount.excuse_c = 'Dummy excuse';
        console.log('freeTrialAccount', freeTrialAccount);
        this._freeTrialInitialized$.next(true);
        this.dataService.requestFreeTrial(freeTrialAccount).subscribe( {
            next:(res) => {
                if (res?.data?.verification_hash) {
                    console.log('requested verification');
                    // TODO - add action number verification
                } else {
                    this.accountService.login(freeTrialAccount.freeTrialDTO, first, res?.data);
                }
            },
            error: (err) => {
                console.error(`creation failed. ${err}`);
            }
        });

    }
}
